import React, { useEffect, useState } from "react";
import { Box } from "theme-ui";
import { useNavigate } from "react-router-dom";
import { getOutstandingDeposits, applyDepositCredit, refundDeposit } from "api/QuoteExpiration";
import { themevals } from "theme/themevals";
import BasicButton from "components/forms/BasicButton";
import { useToast } from "components/toast";

const fmtCurrency = (v: number) => "\u0024" + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const divider = "1px solid #F0F0F0";

const OutstandingDepositsWidget: React.FC = () => {
  const [deposits, setDeposits] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useToast();

  const fetchDeposits = async () => {
    setLoading(true);
    const result = await getOutstandingDeposits();
    setDeposits(Array.isArray(result) ? result : []);
    setLoading(false);
  };

  useEffect(() => { fetchDeposits(); }, []);

  if (loading) return null;
  if (deposits.length === 0) return null;

  const totalCredits = deposits.reduce((sum: number, d: any) => sum + (d.depositAmount || 0), 0);

  return (
    <Box sx={{ marginBottom: "24px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, fontFamily: "Poppins, sans-serif" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: themevals.colors.black }}>Outstanding Deposit Credits</span>
          <span style={{ fontSize: 11, fontWeight: 600, color: "#888", background: "#F2F2F2", padding: "0 6px", borderRadius: 8, lineHeight: "18px" }}>{deposits.length}</span>
        </div>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#276749" }}>{fmtCurrency(totalCredits)} total</span>
      </div>
      <div style={{ border: divider, borderRadius: 6, overflow: "hidden", fontFamily: "Poppins, sans-serif" }}>
        {deposits.map((dep: any, i: number) => (
          <div key={dep.quoteId} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", borderBottom: i < deposits.length - 1 ? divider : "none" }}>
            <span style={{ width: 3, alignSelf: "stretch", borderRadius: 2, backgroundColor: "#38B2AC", flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 500, color: themevals.colors.black, lineHeight: "18px" }}>
                {dep.clientName || "Unknown"}{" \u2014 "}
                <span style={{ fontWeight: 600 }}>{fmtCurrency(dep.depositAmount || 0)}</span>
              </div>
              <div style={{ fontSize: 11, color: "#888", lineHeight: "16px" }}>
                {"GMQ-" + String(dep.sequence).padStart(5, "0")}
                {dep.projectName && dep.projectName !== "Untitled" ? " \u00B7 " + dep.projectName : ""}
                {dep.depositMethod ? " \u00B7 " + dep.depositMethod : ""}
              </div>
            </div>
            <button onClick={() => navigate("/quotes/" + dep.quoteId)} style={{
              fontFamily: "Poppins", fontSize: 11, fontWeight: 500, cursor: "pointer", flexShrink: 0,
              border: "1px solid #D0D0D0", borderRadius: 4, padding: "3px 10px", lineHeight: "18px",
              color: themevals.colors.black, backgroundColor: "transparent",
            }}>View Quote</button>
          </div>
        ))}
      </div>
    </Box>
  );
};

export default OutstandingDepositsWidget;
